import { JsonObject } from 'json2typescript';
import GoodsOption from './GoodsOption';

@JsonObject('CartItem')
export default class CartItem {
  constructor() {
    this.goodsCode = '';
    this.goodsTitle = '';
    this.quantity = 1;
    this.canBuy = false;
    this.fee = 0;
    this.periodStart = '';
    this.periodEnd = '';
    this.goodsItemOptions = new Array<GoodsOption>();
  }

  public goodsCode: string;

  public goodsTitle: string;

  public quantity: number;

  public canBuy: boolean;

  public fee: number;

  public periodStart: string;

  public periodEnd: string;

  public goodsItemOptions: Array<GoodsOption>;
}
